export const pulseAnimation = {
  initial: {
    opacity: 0,
    boxShadow: '0 0 0 0 rgba(59, 130, 246, 0.4)'
  },
  animate: {
    opacity: [0, 0.45, 0],
    boxShadow: [
      '0 0 0 0 rgba(59, 130, 246, 0.4)',
      '0 0 12px 3px rgba(59, 130, 246, 0.3)',
      '0 0 0 0 rgba(59, 130, 246, 0)'
    ],
    transition: {
      duration: 0.7,
      ease: 'easeOut'
    }
  }
};

export const segmentIndicatorAnimation = {
  initial: {
    opacity: 0,
    y: 0
  },
  animate: {
    opacity: [0, 1, 0],
    y: -8,
    transition: {
      duration: 0.5
    }
  }
};

export const badgeAnimation = {
  initial: {
    opacity: 0,
    scale: 0.9,
    y: 5
  },
  animate: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 500,
      damping: 25
    }
  },
  exit: {
    opacity: 0,
    scale: 0.9,
    y: 5
  }
};

export const pillDeleteAnimation = {
  initial: {
    opacity: 1,
    filter: 'blur(0px)',
    scale: 1
  },
  exit: {
    opacity: 0,
    filter: 'blur(4px)',
    scale: 0.95,
    transition: {
      duration: 0.2,
      ease: 'easeOut'
    }
  }
};

export const commandListAnimation = {
  initial: {
    opacity: 0,
    scale: 0.95
  },
  animate: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.1,
      ease: [0.32, 0.72, 0, 1]
    }
  },
  exit: {
    opacity: 0,
    scale: 0.95
  }
};

export const commandButtonAnimation = {
  initial: {},
  whileHover: {
    scale: 1.01
  },
  whileTap: {
    scale: 0.99
  }
};
